import script from "./CreateActivityModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateActivityModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateActivityModal.vue?vue&type=style&index=0&id=5ced2f84&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ced2f84"]])

export default __exports__